import "./Arrow.css";

const Arrow = () => {
  return (
    <svg
      className="Arrow"
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="arrowGradient">
          <stop offset="0%" stopColor="#762af3" />
          <stop offset="100%" stopColor="#d8468b" />
        </linearGradient>
      </defs>
      <path
        d="M8.22112 0.5L7.11326 1.60786L10.7118 5.21429H0.756836V6.78571H10.7118L7.10541 10.3921L8.22112 11.5L13.7211 6L8.22112 0.5Z"
        fill="black"
      />
    </svg>
  );
};

export default Arrow;
